export default "__VITE_ASSET__4J0Kxe6A__"